import { BuzzerTone, isKeyenceEnterpriseBrowser, KeyenceModule } from '@/utils/keyenceHT/keyenceModules'

export type KeyenceHTBuzzerOptions = {
  tone?: BuzzerTone
  onPeriodMilliseconds?: number
  offPeriodMilliseconds?: number
  repeatCount?: number
}

const defaultKeyenceHTBuzzerOptions: Required<KeyenceHTBuzzerOptions> = {
  tone: 8,
  onPeriodMilliseconds: 100,
  offPeriodMilliseconds: 100,
  repeatCount: 3,
}

export function playBuzzer3times(options: KeyenceHTBuzzerOptions = {}): void {
  if (!isKeyenceEnterpriseBrowser() || !KeyenceModule?.Notification) {
    return
  }

  const buzzerOptions = { ...defaultKeyenceHTBuzzerOptions, ...options }

  KeyenceModule.Notification.startBuzzer(
    buzzerOptions.tone,
    buzzerOptions.onPeriodMilliseconds,
    buzzerOptions.offPeriodMilliseconds,
    buzzerOptions.repeatCount
  )
}
